import { Component } from "react";

/** Catches render/runtime exceptions so the preview never shows a raw runtime error. */
export class ErrorBoundary extends Component {
  state = { failed: false };

  static getDerivedStateFromError() {
    return { failed: true };
  }

  componentDidCatch(error) {
    // Deliberately minimal: no props, no form values, no customer data.
    // eslint-disable-next-line no-console
    console.error(`[ArtPart] Render error: ${error?.name || "Error"}`);
  }

  render() {
    if (!this.state.failed) return this.props.children;
    return (
      <div
        data-testid="error-boundary"
        className="flex min-h-screen items-center justify-center bg-paper px-5"
      >
        <div className="max-w-md text-center">
          <p className="ap-stamp">ARTPART</p>
          <h1 className="ap-h2 mt-4 text-ink">Kurz aus dem Takt.</h1>
          <p className="ap-body mt-4 text-charcoal">
            Diese Ansicht konnte nicht geladen werden. Lade die Seite neu – deine Anfrage kannst du
            danach normal absenden.
          </p>
          <button
            type="button"
            onClick={() => window.location.reload()}
            className="ap-btn-solid mt-8"
            data-testid="error-boundary-reload"
          >
            Seite neu laden
          </button>
        </div>
      </div>
    );
  }
}

export const LoadState = ({ status, error, onRetry, label = "Archiv wird geladen" }) => (
  <div className="flex min-h-screen items-center justify-center bg-paper px-5" data-testid="load-state">
    {status === "error" ? (
      <div className="max-w-md text-center">
        <p className="ap-stamp">ARTPART</p>
        <h1 className="ap-h2 mt-4 text-ink">Verbindung unterbrochen.</h1>
        <p className="ap-body mt-4 text-charcoal" data-testid="load-error-message">
          {error}
        </p>
        <button type="button" onClick={onRetry} className="ap-btn-solid mt-8" data-testid="load-retry">
          Erneut versuchen
        </button>
      </div>
    ) : (
      <p className="ap-stamp" data-testid="load-spinner">
        {label}
      </p>
    )}
  </div>
);
